<div class="not-found">
    <p class="error">
        <span class="error-four">4</span>
        <span class="error-zero">0</span>
        <span class="error-four">4</span>
    </p>
    <div class="error-texts">
        <p class="error-text">صفحه ای که به دنبال آن هستید،</p>
        <p class="error-text">در این آدرس وجود ندارد.</p>
    </div>
    <div class="error-back-btn">
        <a href="/" class="error-back-btn-txt">بازگشت به صفحه اصلی</a>
    </div>
</div>